import React, { useLayoutEffect, useRef } from 'react'
import { GridRenderEditCellParams } from '@mui/x-data-grid'
import { useNumberDraft } from './NumberInput'

type NumberEditCellProps = GridRenderEditCellParams & {
  decimals?: number
  min?: number
  max?: number
}

/** DataGrid edit cell with the same typing rules as NumberInput. */
export default function NumberEditCell({
  id,
  field,
  value,
  api,
  hasFocus,
  decimals = 2,
  min,
  max,
}: NumberEditCellProps) {
  const ref = useRef<HTMLInputElement>(null)
  const { inputProps } = useNumberDraft({
    value: value as number | null,
    onChange: (next) => api.setEditCellValue({ id, field, value: next }),
    decimals,
    min,
    max,
  })

  useLayoutEffect(() => {
    if (hasFocus) ref.current?.focus()
  }, [hasFocus])

  return <input ref={ref} {...inputProps} className="incyia-number-edit-cell" />
}
